import { render, staticRenderFns } from "./HandoverTenancyMove.vue?vue&type=template&id=41d8dc7c&scoped=true"
import script from "./HandoverTenancyMove.vue?vue&type=script&lang=js"
export * from "./HandoverTenancyMove.vue?vue&type=script&lang=js"
import style0 from "./HandoverTenancyMove.vue?vue&type=style&index=0&id=41d8dc7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d8dc7c",
  null
  
)

export default component.exports